<template>
    <div class="my-3" v-if="showLogos">
        <FeaturedProducts v-if="featured && featured.length > 5" :is_suggested="true" title="Featured Products"
            suggested_type="featured" :routes="routes" :products="featured_render" :cart_items="cart_items"
            :productLink="productLink" :viewAllRoute="this.route(this.categoryRoute, this.$page.props.const.cat_featured)"
            :isWholesale="isWholesale" @getCartItems="$emit('getCartItems')" />

        <div class="bg-white p-3">
            <div v-if="showLogos" class="manufacturers-list row mb-4">
                <div class="col-sm-2 d-none d-sm-block">
                    <div v-for="manufacturer in $page.props.manufacturers_select" :key="manufacturer.value">
                        <strong><inertia-link
                                :href="route(routes.shop, mergeQueryParams({ manufacturer: manufacturer.value }))">{{
                                    manufacturer.label }}</inertia-link></strong>
                    </div>
                </div>
                <div class="col-sm-10">
                    <div class="row">
                        <div @click="customProducts" v-if="$page.props.has_custom"
                            class="col-6 col-md-4 col-lg-3 my-2 cursor-pointer flex-center px-2 px-lg-4 custom-product-link logo-container">
                            <img v-if="$page.props.auth.user.logo_url" :src="$page.props.auth.user.logo_url" />
                            <div v-else class="content">
                                <p class="m-0 font-weight-bold">
                                    <i class="fas fa-tools text-primary flex-center fa-lg mr-2"></i>
                                    <span
                                        class="title d-block lh-small text-center mt-2">{{ $page.props.auth.user.company_name }}
                                        products</span>
                                </p>
                            </div>
                        </div>
                        <div v-for="manufacturer in $page.props.manufacturers" :key="manufacturer.value"
                            class="col-6 col-md-4 col-lg-3 my-2 cursor-pointer flex-center px-2 px-lg-4 logo-container"
                            @click="logoClicked(manufacturer)">
                            <img class="px-2" :src="manufacturer.logo" :alt="`${manufacturer.label} logo`"
                                :title="manufacturer.label" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FeaturedProducts from '@/Components/Shop/FeaturedProducts'

export default {
    data() {
        return {
            featured_render: this.featured ? this.featured.slice(0, 12) : [],
        }
    },
    components: {
        FeaturedProducts
    },
    props: {
        routes: Object,
        cart_items: [Boolean, Array],
        productLink: String,
        featured: Array,
        categoryRoute: {
            type: String,
            default: ''
        },
        isWholesale: Boolean
    },
    methods: {
        logoClicked(manufacturer) {
            this.$page.props.manufacturer_id = manufacturer.value
        },
        customProducts() {
            this.$inertia.visit(this.route(this.categoryRoute, {
                category: this.$page.props.category_id || '',
                _query: {
                    manufacturer: this.$page.props.manufacturer_id,
                    query: this.$page.props.query,
                    custom: 1
                }
            }))
        }
    },
    computed: {
        showLogos() {
            return !this.$page.props.manufacturer_id && 
            !this.$page.props.query && 
            !this.$page.props.sale_id && 
            !this.$page.props.category_id && 
            !this.$page.props.custom
        }
    }
}
</script>
